// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.board-theming-popup {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  background-color: #144258;
  color: white;
  font-size: 20px;
  font-family: sans-serif;
  border-radius: 8px;
  padding: 5px 0 0px 0px;
  touch-action: none;
  z-index: 1000;
  position: absolute;
  bottom: 10px;
  left: 10px;
  /* This makes things *much* easier */
  box-sizing: border-box;
}
.board-theming-popup #moveHandler {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 16px, rgba(0, 0, 0, 0.3) 0px 3px 14px;
  width: 100%;
  color: white;
  background-color: #3d4e55;
  border-radius: 10px;
  cursor: move;
  user-select: none;
  text-align: center;
  font-size: small;
  height: 20px;
  margin-bottom: 5px;
  padding: 2px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
